var _path, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModifyInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3077 6.68313C20.3084 6.56165 20.2852 6.44122 20.2392 6.32875C20.1933 6.21629 20.1256 6.114 20.0401 6.02775L16.1262 2.1139C16.04 2.02835 15.9377 1.96066 15.8252 1.91473C15.7127 1.86879 15.5923 1.8455 15.4708 1.84621C15.3493 1.8455 15.2289 1.86879 15.1164 1.91473C15.004 1.96066 14.9017 2.02835 14.8154 2.1139L12.2031 4.72621L2.1139 14.8154C2.02835 14.9017 1.96066 15.004 1.91473 15.1164C1.86879 15.2289 1.8455 15.3493 1.84621 15.4708V19.3847C1.84621 19.6295 1.94346 19.8643 2.11657 20.0374C2.28968 20.2105 2.52447 20.3077 2.76928 20.3077H6.68313C6.81229 20.3148 6.94149 20.2946 7.06235 20.2485C7.1832 20.2023 7.29302 20.1313 7.38467 20.0401L17.4185 9.95082L20.0401 7.38467C20.1243 7.2952 20.193 7.19224 20.2431 7.08005C20.252 7.00647 20.252 6.93209 20.2431 6.85851C20.2474 6.81555 20.2474 6.77225 20.2431 6.72928L20.3077 6.68313ZM6.30467 18.4616H3.69236V15.8493L12.8585 6.68313L15.4708 9.29544L6.30467 18.4616ZM16.7724 7.9939L14.1601 5.38159L15.4708 4.08005L18.0739 6.68313L16.7724 7.9939Z",
    fill: "#949494"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.84619,
    y1: 23,
    x2: 19.3077,
    y2: 23,
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyInfo);
export default __webpack_public_path__ + "static/media/ModifyInfo.1eeed58c67bfa013bc640324fbdf3532.svg";
export { ForwardRef as ReactComponent };